export default __webpack_public_path__ + "static/media/S-PU1H5_Gallery_3.8d2c9483.jpg";